import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function startGoogleLogin() {
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export function GoogleIcon({ className = "h-4 w-4" }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
      <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z" />
      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
      <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18A11 11 0 0 0 1 12c0 1.77.42 3.45 1.18 4.93l2.85-2.22.81-.62z" />
      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
    </svg>
  );
}

export function GooglePrompt() {
  const { user, loading } = useAuth();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (loading || user) return;
    if (sessionStorage.getItem("fu_google_prompt_dismissed")) return;
    if (window.location.hash?.includes("session_id=")) return;
    const t = setTimeout(() => setOpen(true), 1200);
    return () => clearTimeout(t);
  }, [loading, user]);

  if (!open || user) return null;
  const dismiss = () => {
    sessionStorage.setItem("fu_google_prompt_dismissed", "1");
    setOpen(false);
  };
  return (
    <div className="fixed right-4 top-20 z-50 w-[calc(100%-2rem)] max-w-sm animate-rise rounded-2xl border border-slate-200 bg-white p-4 shadow-xl sm:right-6" role="dialog" aria-label="Sign in with Google" data-testid="google-prompt">
      <button onClick={dismiss} className="absolute right-3 top-3 rounded-full p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-700" aria-label="Dismiss" data-testid="google-prompt-dismiss"><X className="h-4 w-4" /></button>
      <p className="pr-6 text-sm font-semibold text-slate-900">Sign in for longer storage</p>
      <p className="mt-1 text-xs text-slate-500">Get 50 GB and unlimited file retention with a free account.</p>
      <button onClick={startGoogleLogin} className="mt-3 flex w-full items-center justify-center gap-2 rounded-xl border border-slate-200 bg-white px-4 py-2.5 text-sm font-medium text-slate-800 transition-colors hover:bg-slate-50" data-testid="google-prompt-continue">
        <GoogleIcon /> Continue with Google
      </button>
    </div>
  );
}
